import React, { FunctionComponent } from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import {
  CopyableText, Loading, ResultsEmpty,
} from '..';
import { ReadOnlyText } from '../copyable-text';
import { ReactComponent as EyeShow } from '../../assets/eye-show.svg';
import { ReactComponent as EyeHide } from '../../assets/eye-hide.svg';

export interface UserIntegrationCredentialsBoxProps {
  isLoadingCreate: boolean;
  username: string;
  password: string;
  onClickShowPassword: () => void;
  isLoadingPassword: boolean;
  hidePassword: () => void;
}

const UserIntegrationCredentialsBox: FunctionComponent<
UserIntegrationCredentialsBoxProps> = ({
  isLoadingCreate, username, password, onClickShowPassword, isLoadingPassword, hidePassword,
}: UserIntegrationCredentialsBoxProps) => {
  if (isLoadingCreate) {
    return (
      <Flex alignItems="center" justifyContent="center" height="100%">
        <Loading size={24} />
      </Flex>
    );
  }

  if (!username) {
    return <Box data-testid="user-integration-empty-container"><ResultsEmpty text="You have no user yet" /></Box>;
  }

  return (
    <Box>
      <Flex pr={3}>
        <Box flex={1} pr={3} maxWidth="368px">
          <Text mb={3} variant="p1" sx={{ textTransform: 'uppercase' }}>User ID</Text>
          <Box height="42px">
            <CopyableText text={username} copyEnabled={!!username} testId="user-integration-username" />
          </Box>
        </Box>

        <Box flex={1} pl={3} maxWidth="368px">
          <Text mb={3} variant="p1" sx={{ textTransform: 'uppercase' }}>Password</Text>
          <Box height="42px">
            {password ? (
              <CopyableText
                text={password}
                rightIcon={<EyeHide />}
                onClickAdornment={() => {
                  hidePassword();
                }}
                copyEnabled
              />
            ) : (
              <Box onClick={onClickShowPassword} height="100%">
                <ReadOnlyText>
                  <Flex flexDirection="column" justifyContent="center" flex={1}>**********</Flex>
                  <Box>{isLoadingPassword ? <Loading size={24} /> : <Flex height="100%" flexDirection="column" justifyContent="center"><Text variant="primary"><EyeShow /></Text></Flex>}</Box>
                </ReadOnlyText>
              </Box>
            )}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default UserIntegrationCredentialsBox;
